import React, { useState } from 'react';
import { FaEdit } from "react-icons/fa";
import {
    Button,
    Form,
    Input,
    Modal,
    InputNumber,
    Switch,
    message
} from 'antd';
import dayjs from 'dayjs';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function EditFormModal({ data }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: ({ values, id }) => {
            axios
                .put(`/api/products/editCourse/${id}`, values)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'Update successfully',
                        duration: 1,
                        onClose: () => setOpen(false)
                    });
                    queryClient.invalidateQueries(['/api/products/findCourses'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Update failed!',
                    });
                })
        },
    });


    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ values, id: data._id }))
    };

    const onCancelCreate = () => {
        setOpen(false);
    }
    // console.log(data);
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<FaEdit />}
                style={{ color: '#5f77fc' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title="Edit Course"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        Ok
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={{
                        ...data,
                        start_date: dayjs(data.start_date).isValid() ? dayjs(data.start_date) : null
                    }}
                >
                    <Form.Item
                        name="name"
                        label="Course Name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Price"
                        name="price"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <InputNumber min={0} style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item name="description" label="Description">
                        <Input.TextArea rows={2} />
                    </Form.Item>
                    <Form.Item label="สถานะ" name="is_active" valuePropName="checked">
                        <Switch checkedChildren="Active" unCheckedChildren="Not Active" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
